import {
    NotificationItemMutation,
    NotificationMessagesListTransaction,
} from '../../../interfaces';

export const mutationsToTransactionNotifications =
    (mutations: Array<NotificationItemMutation>): NotificationMessagesListTransaction => ({
        update: mutations,
    });
